import { useMemo } from 'react'
import { Box, Select, Text } from 'ui'
import { SelectableCompanyGroup } from 'typings/selectable_ext'
import { CompanySwitchIndicator } from 'components/CompanySwitchIndicator'
import { useSwitchCompanyMutation } from 'queries/company'
import { createPortal } from 'react-dom'
import { useAuthContext } from 'components/auth'

export const CompanySwitcher = () => {
  const { company, companies } = useAuthContext()

  const companyOptions = useMemo(() => {
    return companies.map((c) => ({
      value: Number(c.id),
      label: c.name,
    }))
  }, [companies])

  const { mutate: switchCompany, isPending: isSwitching } =
    useSwitchCompanyMutation()

  const handleCompanyChange = (selectedOption: SelectableCompanyGroup) => {
    if (!selectedOption || !company) {
      return
    }
    switchCompany(Number(selectedOption.value))
  }

  if (!company || companyOptions.length === 0) {
    return null
  }

  const selectedCompany = companyOptions.find((o) => o.value === company.id)

  return (
    <>
      <Box>
        <Box mb={2}>
          <Text color={'lightText'} maxLines={1}>
            Currently viewing:
          </Text>
        </Box>
        <Select
          options={companyOptions}
          onChange={(selectedOption) => {
            handleCompanyChange(selectedOption as SelectableCompanyGroup)
          }}
          value={selectedCompany}
        />
      </Box>
      {isSwitching
        ? createPortal(<CompanySwitchIndicator />, document.body)
        : null}
    </>
  )
}
